import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

import { BidPrequalification, RepositoryModal } from '../../shared'

@Component({
    templateUrl: './prequalification.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent],
})
export class PrequalificationComponent extends RepositoryModal<BidPrequalification> {}
